// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__SqKZz","footer":"Footer_footer__3Ovlm"};